<mat-card class="ra-card tube-card" *ngIf="isVisible">
    <mat-card-content class="tube-card-content">
        <span (click)="close()" class="fas fa-times close-btn"></span>
        <app-single-tubemap [selectedTrain]="selectedTrain" [selectedMetricId]="selectedMetricId"></app-single-tubemap>
    </mat-card-content>
</mat-card>